import React from "react";
import { DayForm } from "./DayForm";
import { SelectCategories } from "./SelectCategories";
import { SelectCatalogues } from "./SelectCatalogues";

export class ReportModal extends React.Component {

  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    report: null,
    selectedReport: 'Product Orders by Customers',
    scheduleDays: [],
    scheduleTime: '',
    emails: '',
    parameters: {}
  }

  componentWillMount() {
    if (this.props.report) {
      this.setState({
        report: this.props.report,
        selectedReport: this.props.report.reportName,
        scheduleDays: JSON.parse(this.props.report.schedule).days,
        scheduleTime: JSON.parse(this.props.report.schedule).time,
        emails: this.props.report.emails,
        parameters: JSON.parse(this.props.report.parameters)
      })
    }
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  updateDays(arr) {
    this.setState({ scheduleDays: arr })
  }

  updateParameters(obj) {
    this.setState({ parameters: obj })
  }

  saveChanges = async () => {
    this.props.closeModal()
    this.props.saveChanges(this.state)
  }

  render() {
    return (
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add/Edit Scheduled Report</h5>
            <button type="button" className="close" onClick={this.props.closeModal}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <h5>Report Settings</h5>
            <div className="form-group">
              <label>Report:</label>
              <div className="input-select">
                <select value={this.state.selectedReport} onChange={this.handleChange} className="form-control" name="selectedReport">
                  <option>Product Orders by Customers</option>
                  <option>Total Ordered Products</option>
                  <option>Fresh Produce Orders</option>
                  <option>Order Picking Slips</option>
                </select>
              </div>
            </div>
            {this.state.selectedReport === 'Total Ordered Products' ? 
            <>
              <h5>Filter</h5>
              <div className="form-group">
                <SelectCategories updateParameters={this.updateParameters.bind(this)} filter={this.state.parameters.filter} />
              </div>
            </>
            : null}
            {this.state.selectedReport === 'Product Orders by Customers' ? 
            <>
              <h5>Filter</h5>
              <div className="form-group">
                <SelectCatalogues updateParameters={this.updateParameters.bind(this)} filter={this.state.parameters.filter} />
              </div>
            </>
            : null}
            <h5>Schedule</h5>
            <div className="form-group">
              <label>Every:</label>
              <DayForm updateDays={this.updateDays.bind(this)} daysArr={this.state.scheduleDays} />
            </div>
            <div className="form-group">
              <label>At:</label>
              <input type="time" className="form-control" name="scheduleTime" value={this.state.scheduleTime} onChange={this.handleChange} step="3600000"/>
            </div>
            <div className="form-group">
              <label>Emails:</label>
              <textarea className="form-control" name="emails" rows="2" value={this.state.emails} onChange={this.handleChange} />
              <p className="small">Enter multiple emails using a comma e.g. john@example.com, doe@example.com</p>            
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={this.props.closeModal}>Close</button>
            <button type="button" onClick={this.saveChanges} className="btn btn-primary" disabled={!this.state.scheduleTime || !this.state.scheduleDays}>Save changes</button>
          </div>
        </div>
      </div>
    );
  }
}